<template>
  <div>
    <!-- 移动端视图 - 根据当前显示的内容决定显示哪个移动端组件 -->
    <template v-if="isMobile">
      <!-- 公司介绍、董事长致辞、光辉历程、资质荣誉、概貌剪影 使用 MobileIntroduction -->
      <MobileIntroduction v-if="showMobileIntroduction" />
      
      <!-- 党建工作的移动端页面 -->
      <MobilePartyBuildingWork v-else-if="partyBuildingWorkShow" />
      
      <!-- 社会责任的移动端页面 -->
      <MobileSocialResponsibility v-else-if="socialResponsibilityShow" />
      
      <!-- 领导关怀的移动端页面 -->
      <MobileLeadershipCare v-else-if="leadershipCareShow" />
      
      <!-- 企业文化的移动端页面 -->
      <MobileCorporateCulture v-else-if="corporateCultureShow" />
      
      <!-- 人力资源的移动端页面 -->
      <MobileHumanResources v-else-if="humanResourcesShow" />
    </template>
    
    <!-- PC端视图 -->
    <div v-else class="grid-container">
      <div class="swiper-slide">
        <div class="p_img">
          <a href="javascript:;">
            <img src="../../../assets/aboutSailHero/img/banner_1.jpg" alt="关于先河" title="关于先河">
          </a>
        </div>
        <div class="p_info">
          <div>
            <h2 class="text-white p_btitle">关于先河</h2>
            <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
          </div>
        </div>
      </div>
<!--    <div class="image_1"/>-->
<!--    <div class="p_info anim">-->
<!--      <div class="p_btitle">关于先河</div>-->
<!--      <div class="p_subtitle">About Us</div>-->
<!--    </div>-->
    <div class="middle">
      <div class="left">
        <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;关于先河</span>
        <div class="group_3 flex-col">
          <div class="box_7 flex-col justify-between">
            <span class="text_14">公司介绍</span>
            <img
                class="image_2"
                referrerpolicy="no-referrer"
                :src="require('@/assets/aboutSailHero/img/dx_1.jpg')"
            />
          </div>
          <div class="box_9 box flex-row justify-between" :style="{'color':companyIntroductionShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showCompanyIntroduction()">
            <span class="text_16" :style="{'font-weight':companyIntroductionShow?'600':'normal'}">公司介绍</span>
            <img
                class="thumbnail_3"
                referrerpolicy="no-referrer"
                :src="companyIntroductionShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 box flex-row justify-between" :style="{'color':chairmanSpeechShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showChairmanSpeech()">
            <span class="text_17" :style="{'font-weight':chairmanSpeechShow?'600':'normal'}">董事长致辞</span>
            <img
                class="thumbnail_4"
                referrerpolicy="no-referrer"
                :src="chairmanSpeechShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_6 flex-col"></div>
          <div class="group_7 box flex-row justify-between" :style="{'color':gloriousHistoryShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showGloriousHistory()">
            <span class="text_18" :style="{'font-weight':gloriousHistoryShow?'600':'normal'}">光辉历程</span>
            <img
                class="thumbnail_5"
                referrerpolicy="no-referrer"
                :src="gloriousHistoryShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_8 flex-col"></div>
          <div class="group_9 box flex-row justify-between" :style="{'color':qualificationsHonorsShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showQualificationsHonors()">
            <span class="text_19" :style="{'font-weight':qualificationsHonorsShow?'600':'normal'}">资质荣誉</span>
            <img
                class="thumbnail_6"
                referrerpolicy="no-referrer"
                :src="qualificationsHonorsShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_10 flex-col"></div>
          <div class="group_11 box flex-row justify-between" :style="{'color':overviewSilhouetteShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showOverviewSilhouette()">
            <span class="text_20" :style="{'font-weight':overviewSilhouetteShow?'600':'normal'}">概貌剪影</span>
            <img
                class="thumbnail_7"
                referrerpolicy="no-referrer"
                :src="overviewSilhouetteShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_10 flex-col"></div>
          <div class="group_11 box flex-row justify-between" :style="{'color':partyBuildingWorkShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showPartyBuildingWork()">
            <span class="text_20" :style="{'font-weight':partyBuildingWorkShow?'600':'normal'}">党建工作</span>
            <img
                class="thumbnail_7"
                referrerpolicy="no-referrer"
                :src="partyBuildingWorkShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_12 flex-col"></div>
          <div class="group_13 box flex-row justify-between" :style="{'color':socialResponsibilityShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showSocialResponsibility()">
            <span class="text_21" :style="{'font-weight':socialResponsibilityShow?'600':'normal'}">社会责任</span>
            <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                :src="socialResponsibilityShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_14 flex-col"></div>
          <div class="group_15 box flex-row justify-between" :style="{'color':leadershipCareShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showLeadershipCare()">
            <span class="text_22" :style="{'font-weight':leadershipCareShow?'600':'normal'}">领导关怀</span>
            <img
                class="thumbnail_9"
                referrerpolicy="no-referrer"
                :src="leadershipCareShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_16 flex-col"></div>
          <div class="group_17 box flex-row justify-between" :style="{'color':corporateCultureShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showCorporateCulture()">
            <span class="text_23" :style="{'font-weight':corporateCultureShow?'600':'normal'}">企业文化</span>
            <img
                class="thumbnail_10"
                referrerpolicy="no-referrer"
                :src="corporateCultureShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_16 flex-col"></div>
          <div class="group_17 box flex-row justify-between" :style="{'color':humanResourcesShow?'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)'}" @click="showHumanResources()">
            <span class="text_23" :style="{'font-weight':humanResourcesShow?'600':'normal'}">人力资源</span>
            <img
                class="thumbnail_10"
                referrerpolicy="no-referrer"
                :src="humanResourcesShow?require('@/assets/aboutSailHero/img/icon_fh1.png'):require('@/assets/aboutSailHero/img/icon_fh2.png')"
            />
          </div>
          <div class="group_16 flex-col"></div>
        </div>
      </div>
      <div class="right">
        <CompanyIntroduction v-show="companyIntroductionShow"></CompanyIntroduction>
        <ChairmanSpeech v-show="chairmanSpeechShow"></ChairmanSpeech>
        <GloriousHistory v-show="gloriousHistoryShow"></GloriousHistory>
        <QualificationsHonors v-show="qualificationsHonorsShow"></QualificationsHonors>
        <OverviewSilhouette v-show="overviewSilhouetteShow"></OverviewSilhouette>
        <SocialResponsibility v-show="socialResponsibilityShow"></SocialResponsibility>
        <LeadershipCare v-show="leadershipCareShow"></LeadershipCare>
        <CorporateCulture v-show="corporateCultureShow"></CorporateCulture>
        <PartyBuildingWork v-show="partyBuildingWorkShow"></PartyBuildingWork>
        <HumanResources v-show="humanResourcesShow"></HumanResources>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import CompanyIntroduction from "./components/CompanyIntroduction"
import ChairmanSpeech from "./components/ChairmanSpeech"
import GloriousHistory from "./components/GloriousHistory"
import QualificationsHonors from "./components/QualificationsHonors"
import OverviewSilhouette from "./components/OverviewSilhouette"
import SocialResponsibility from "./components/SocialResponsibility"
import LeadershipCare from "./components/LeadershipCare"
import CorporateCulture from "./components/CorporateCulture"
import PartyBuildingWork from "./components/PartyBuildingWork"
import HumanResources from "./components/HumanResources"
import MobileIntroduction from "./MobileIntroduction.vue"
import MobilePartyBuildingWork from "./MobilePartyBuildingWork.vue"
import MobileSocialResponsibility from "./MobileSocialResponsibility.vue"
import MobileLeadershipCare from "./MobileLeadershipCare.vue"
import MobileCorporateCulture from "./MobileCorporateCulture.vue"
import MobileHumanResources from "./MobileHumanResources.vue"

export default {
  components: {
    CompanyIntroduction,
    ChairmanSpeech,
    GloriousHistory,
    QualificationsHonors,
    OverviewSilhouette,
    SocialResponsibility,
    LeadershipCare,
    CorporateCulture,
    PartyBuildingWork,
    HumanResources,
    MobileIntroduction,
    MobilePartyBuildingWork,
    MobileSocialResponsibility,
    MobileLeadershipCare,
    MobileCorporateCulture,
    MobileHumanResources
  },
  name: "index",
  data() {
    return {
      isMobile: false, // 是否为移动端
      resizeTimer: null, // 防抖定时器
      companyIntroductionShow:true,//公司介绍选中
      chairmanSpeechShow:false,//董事长致辞选中
      gloriousHistoryShow:false,//光辉历程选中
      qualificationsHonorsShow:false,//资质荣誉选中
      overviewSilhouetteShow:false,//概貌剪影选中
      partyBuildingWorkShow:false,//党建工作选中
      socialResponsibilityShow:false,//社会责任选中
      leadershipCareShow:false,//领导关怀选中
      corporateCultureShow:false,//企业文化选中
      humanResourcesShow:false,//人力资源选中
    }
  },
  computed: {
    // 判断是否显示 MobileIntroduction 组件
    // 当显示以下5个模块时，使用 MobileIntroduction：
    // 1. 公司介绍 2. 董事长致辞 3. 光辉历程 4. 资质荣誉 5. 概貌剪影
    showMobileIntroduction() {
      return this.companyIntroductionShow || 
             this.chairmanSpeechShow || 
             this.gloriousHistoryShow || 
             this.qualificationsHonorsShow || 
             this.overviewSilhouetteShow;
    }
  },
  methods: {
    // 检查是否为移动端
    checkIsMobile() {
      const newIsMobile = window.innerWidth <= 768;
      if (this.isMobile !== newIsMobile) {
        this.isMobile = newIsMobile;
        // 强制更新视图
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    // 处理窗口大小变化（防抖优化）
    handleResize() {
      // 清除之前的定时器
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      // 设置新的定时器，300ms后执行检查
      this.resizeTimer = setTimeout(() => {
        this.checkIsMobile();
      }, 300);
    },
    showCompanyIntroduction(){
      var _this = this;
      if (_this.companyIntroductionShow === true){
      }else {
        _this.companyIntroductionShow = true;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showChairmanSpeech(){
      var _this = this;
      if (_this.chairmanSpeechShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = true;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showGloriousHistory(){
      var _this = this;
      if (_this.gloriousHistoryShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = true;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showQualificationsHonors(){
      var _this = this;
      if (_this.qualificationsHonorsShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = true;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showOverviewSilhouette(){
      var _this = this;
      if (_this.overviewSilhouetteShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = true;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showSocialResponsibility(){
      var _this = this;
      if (_this.socialResponsibilityShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = true;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showLeadershipCare(){
      var _this = this;
      if (_this.leadershipCareShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = true;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showCorporateCulture(){
      var _this = this;
      if (_this.corporateCultureShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = true;
        _this.humanResourcesShow = false;
      }
    },
    showPartyBuildingWork(){
      var _this = this;
      if (_this.partyBuildingWorkShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = true;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = false;
      }
    },
    showHumanResources(){
      var _this = this;
      if (_this.humanResourcesShow === true){
      }else {
        _this.companyIntroductionShow = false;
        _this.chairmanSpeechShow = false;
        _this.gloriousHistoryShow = false;
        _this.qualificationsHonorsShow = false;
        _this.overviewSilhouetteShow = false;
        _this.partyBuildingWorkShow = false;
        _this.socialResponsibilityShow = false;
        _this.leadershipCareShow = false;
        _this.corporateCultureShow = false;
        _this.humanResourcesShow = true;
      }
    },
  },
  mounted(){
      // 初始检查是否为移动端
      this.checkIsMobile();
      // 监听窗口大小变化
      window.addEventListener('resize', this.handleResize);
      
      if (this.$route.query.hr != null && this.$route.query.hr != undefined) {
          this.showHumanResources();
      }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.box::before{
  display: block;
  content: "";
  position: absolute;
  top: 16px;
  left: 0;
  border-bottom: 4px solid rgba(0, 90, 214, 1);
  width: 0;
  height: 100%;
  transition: .3s all linear;
  /*  transition-delay: 0.1s;*/

}
.box:hover::before{
  width: 148px;
  transition: .3s all linear;
  /* transition-delay: 0.1s;*/
}
/*@import "../../../assets/aboutSailHero/css/index.css";*/
.grid-container {
  margin: auto;
  display: grid;
  grid-template-rows: 1fr auto 0.32fr;
  background-color: rgba(245, 245, 245, 1);
}
.middle{
  display: grid;
  grid-template-columns: 1.5fr 4fr; /* 定义两列，每列占一份可分配空间 */
  justify-items: center; /* 水平方向居中对齐每个网格项 */
  align-items: center; /* 垂直方向居中对齐每个网格项 */
  width: 1920px;
}
.left{
  height: 100%;
  width: 100%;
  position: relative;
}
.right{
  height: 100%;
  width: 100%;
}
.swiper-slide{
  height: 591px;
  width: 1920px;
  overflow: hidden;
  transform: translate3d(0px, 0px, 0px); transition: all; opacity: 1;
}

.p_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  animation: bannerimg 2s;
}

.p_info .p_btitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 59px;
  font-weight: 900;
  letter-spacing: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p_info .p_subtitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 28px;
  font-weight: 400;
  position: relative;
  bottom: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.p_info {
  width: 100%;
  max-width: 1600px;
  padding: 0 5px;
  position: absolute;
  left: 257px;
  top: 120px;
  z-index: 9;
}

@keyframes puBanner {
  from {
    transform: translateY(200px);
    opacity: 0
  }

  to {
    transform: translateY(0);
    opacity: 1
  }
}

@keyframes bannerimg {
  from {
    transform: scale(1.2)
  }

  to {
    transform: scale(1);
  }
}
.box_7 {
  width: 120px;
  height: 50px;
  margin-bottom: 48px;
}
.bottom{
  width: 100%;
  height: 50px;
}

.text_14 {
  width: 120px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(0, 87, 193, 1);
  font-size: 30px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.image_2{
  width: 120px;
  height: 6px;
  margin-top: 14px;
}
.box_9 {
  width: 148px;
  height: 22px;
  cursor: pointer;
  position: relative;
}

.text_16 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
}

.thumbnail_3 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_3 {
  width: 148px;
  height: 366px;
  margin-left: 260px;
  margin-top: 70px;
}

.group_4 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_5 {
  width: 148px;
  height: 22px;
  margin-top: 16px;
  cursor: pointer;
  position: relative;
}
.text_17 {
  width: 100px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_4 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_6 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_7 {
  width: 148px;
  height: 22px;
  margin-top: 15px;
  cursor: pointer;
  position: relative;
}
.text_18 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_5 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_8 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_9 {
  width: 148px;
  height: 22px;
  margin-top: 16px;
  cursor: pointer;
  position: relative;
}
.text_19 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_6 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_10 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_11 {
  width: 148px;
  height: 22px;
  margin-top: 16px;
  cursor: pointer;
  position: relative;
}
.text_20 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_7 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_12 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_13 {
  width: 148px;
  height: 22px;
  margin-top: 14px;
  cursor: pointer;
  position: relative;
}
.text_21 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_8 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_14 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_15 {
  width: 148px;
  height: 22px;
  margin-top: 16px;
  cursor: pointer;
  position: relative;
}
.text_22 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_9 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}
.group_16 {
  background-color: rgba(230, 228, 228, 1);
  width: 148px;
  height: 1px;
  margin-top: 16px;
}
.group_17 {
  width: 148px;
  height: 22px;
  margin-top: 16px;
  cursor: pointer;
  position: relative;
}
.text_23 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}
.thumbnail_10 {
  width: 5px;
  height: 9px;
  margin-top: 7px;
}

.text_13 {
  width: 197px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(118, 118, 118, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  position: relative;
  left: 260px;
  top: 48px;
}

/* 移动端占位符样式 */
.mobile-placeholder {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fb;
  padding: 20px;
  box-sizing: border-box;
}

.mobile-placeholder p {
  font-size: 16px;
  color: #666;
  text-align: center;
  padding: 40px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
